(ns app.front.view.group.admin.allow-workspace-creation-select
  "Component for the admin to select whether category/work type/work target
  should be shown in the wizard for workspaces and in the public map for complaints"
  (:require [app.domain.group.config.model :as config-model]
            [app.domain.group.permit-type-config.model :as ptc-model]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [>evt]]))


(defn allow-workspace-creation-selector [{:keys [config ptc-id tr selected-settings ancestor-configs permit-type]}]
  (when-not (ptc-model/configurable-hidden-types permit-type)
    (let [ancestor-values          (map (fn [config]
                                          (or (get-in selected-settings [(:db/id config) :group.config/allow-workspace-creation])
                                              (:group.config/allow-workspace-creation config)))
                                        ancestor-configs)
          effective-ancestor-value (apply config-model/effective-allow-workspace-creation-value ancestor-values)
          value                    (:group.config/allow-workspace-creation config)
          config-id                (:db/id config)
          selected-value           (get-in selected-settings [config-id :group.config/allow-workspace-creation])
          effective-value          (config-model/effective-allow-workspace-creation-value (or selected-value value)
                                                                                          effective-ancestor-value)
          on-change-fn             (fn [new-value]
                                     (>evt [::gas/update-ptc-group-config-changes
                                            ptc-id
                                            config-id
                                            #(if (= new-value value)
                                               (dissoc % :group.config/allow-workspace-creation)
                                               (assoc % :group.config/allow-workspace-creation new-value))]))]
      [:div.mb-4 {:on-click #(.stopPropagation %)}
       [ui-select/select
        {:id           (str "allow-workspace-creation-" ptc-id "-" config-id)
         :class-name   "select-w-full"
         :label-text   (tr [:group.config/allow-workspace-creation])
         :required     true
         :values       (config-model/allow-workspace-creation-choice effective-ancestor-value)
         :val->str     (comp tr vector)
         :allow-empty? false
         :on-change    on-change-fn
         :value        effective-value}]
       (when (= effective-value :group.config.allow-workspace-creation/none)
         [ui/help
          (tr [:group.config.allow-workspace-creation.help/none]
              [(tr [:group-admin/form-config-title])])
          {:class "p-0"}])])))
